import React from 'react';

export default function RunoffInfoCard({ prevYearData, boxColor, startDate, endDate, runoff}) {

  const totalPrevBalance = prevYearData
    .reduce((acc, item) => acc + item.balance, 0)
    .toFixed(2);

  return (
      <div
        className="pd-20 white mg-y-10"
        style={{
          backgroundColor: boxColor,
          width: '90%',
          borderRadius: '10px',
          color: 'white',
        }}
      >
        <div>
          plus<br />
          <h4>${totalPrevBalance}</h4>
        </div>
        <ul>
          {prevYearData.map((item, index) => (
            <li key={index}>
              {item.name}: ${item.balance}
            </li>
          ))}
        </ul>
        <p>
          Your previous benefit year is still open in run-off. You can still make
          claims for receipts dated from {startDate} - {endDate} if you claim by
          {runoff} at 11:59 PM MT
        </p>
      </div>
  );
}
